import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';

const $container = document.getElementById('tsc-product-finder');
const root = ReactDOM.createRoot($container);
const { ProductFinderHistoryId, Questions } = window.finderData;
root.render(<App id={ProductFinderHistoryId} data={Questions} />);